import { gql } from '@apollo/client/core';

/**
 * Selections for the ticket-layout screens. Keep this in step with `TicketLayout.ts` — every
 * field selected here is mapped there, and nothing more is selected than is mapped.
 *
 * One fragment rather than a list/detail pair: the index, the new form and the edit form all
 * show the same five fields, so a split would buy nothing and would let a list row silently
 * blank a loaded record.
 *
 * The fragment is named `InternalTicketLayoutFields`, not `TicketLayoutFields`: the legacy module
 * defined a fragment under the latter name, and two fragments of one name in a single Apollo
 * document is at best a runtime warning. The legacy module is gone now, but the prefix stays —
 * it matches `InternalAppConfigFields` and every other fragment in this namespace.
 */
export const INTERNAL_TICKET_LAYOUT_FIELDS = gql`
  fragment InternalTicketLayoutFields on TicketLayout {
    id
    name
    fglString
    layout
    default
  }
`;
